(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('AttachmentDeleteModalController', AttachmentDeleteModalController);

    AttachmentDeleteModalController.$inject = ['$uibModalInstance', 'entity', 'Attachment', 'ToastrService'];
    function AttachmentDeleteModalController( $uibModalInstance, entity, Attachment, ToastrService ) {

        var vm = this;

        vm.attachment = entity;

        vm.close = close;
        vm.confirmDelete = confirmDelete;

        function close() {
            $uibModalInstance.dismiss( 'cancel' );
        }

        function confirmDelete() {
            Attachment.delete({id: vm.attachment.id },
                function() {
                    ToastrService.success("Successfully deleted attachment", "Success");
                    $uibModalInstance.close( true );
                }, function( error ) {
                    if( error.status !== 404 ) {
                        ToastrService.error( "Something went wrong: " + error.statusText, "Error" );
                        console.log( error.statusText );
                        $uibModalInstance.dismiss('cancel');
                    }
                })
        }

    }
})();
